export default __webpack_public_path__ + "static/media/gallery_06.38ce9d4d.jpg";